import React from "react";
import { useTranslation } from "react-i18next";

const RevisionHistory = ({ advisoryData }) => {
  const { t } = useTranslation();

  // Extract status and revision history from advisoryData
  const status = advisoryData?.kb_status;
  let revisionHistory = advisoryData?.kb_rev_history || [];
  revisionHistory = [...revisionHistory].reverse();
  const advisoryId = advisoryData?.ntap_advisory_id;

  // Build advisory base URL from the current host so it works across primary and DR domains.
  const domain = new URL("/advisory/", window.location.origin).toString();

  // Construct the full URL
  const advisoryUrl = advisoryId ? `${domain}${advisoryId}` : "#";

  // Mapping of status keys to translation keys
  const statusMapping = {
    final: t("advisory_single_status_final.other"),
    interim: t("advisory_single_status_interim.other"),
  };

  // Get the translated status message
  const translatedStatus = statusMapping[status?.toLowerCase()] || status;

  const disclaimerText = t("advisory_single_disclaimer.other").replace('YEAR', new Date().getFullYear());

  return (
    <div className="overview-content">
      <h2>{t("advisory_single_section_status.other")}</h2>
      <p>
        <strong>{translatedStatus}</strong>
      </p>
      {status?.toLowerCase() === "interim" && (
        <p>{t("advisory_single_noticeInterim.other")}</p>
      )}
      <p>{t("advisory_single_upToDate.other")}</p>

      <p className="inline-text">
        This advisory is posted at the following link:{" "}
      </p>
      <a
        href={advisoryUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-text"
      >
        {advisoryUrl}
      </a>

      <h2>{t("advisory_single_section_revisionHistory.other")}</h2>
      <table className="vulnerability-table">
        <thead>
          <tr>
            <th style={{ width: "10%" }}>
              {t("advisory_single_table_revNum.other")}
            </th>
            <th style={{ width: "10%" }}>
              {t("advisory_single_table_date.other")}
            </th>
            <th style={{ width: "70%" }}>
              {t("advisory_single_table_comments.other")}
            </th>
          </tr>
        </thead>
        <tbody>
          {revisionHistory.length > 0 ? (
            revisionHistory.map((rev, index) => (
              <tr key={index}>
                <td>{rev.version}</td>
                <td>{rev.date}</td>
                <td>{rev.comment}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">
                {t("advisory_single_no_revision_history.other")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="advisory-note">
        {/* <p>{t("advisory_single_disclaimer.other")}</p> */}
        <p>{disclaimerText}</p>
      </div>
    </div>
  );
};

export default RevisionHistory;
